import { Avatar } from '@dixa/lib-shared-habla';
import { convertChannelCasing } from 'lib-shared-api-utils';
import { MetaConversation } from 'lib-shared-legacy-types';

import { AppLink } from 'components/appLink';
import { ConversationDetailsLayout } from 'components/conversation/conversationDetails/conversationDetailsLayout';
import { channelAttributes } from 'utils/channels';

type PropsT = {
  metaConversation: MetaConversation;
  layout: ConversationDetailsLayout;
};

export const RequesterAvatar = (props: PropsT): JSX.Element => {
  const {
    metaConversation: {
      requester,
      conversation: { initial_channel: channel },
    },
    layout,
  } = props;

  const isCollapsedSidebar =
    layout === ConversationDetailsLayout.SidebarCollapsed;

  const channelIcon = channel
    ? channelAttributes[convertChannelCasing(channel, 'snake')]?.icon
    : null;

  const avatar = isCollapsedSidebar ? (
    channelIcon ? (
      <Avatar icon={channelIcon} />
    ) : (
      <Avatar user={requester ?? null} />
    )
  ) : (
    <Avatar user={requester ?? null} />
  );

  if (layout === ConversationDetailsLayout.Overview && requester?.id) {
    return (
      <AppLink
        path="/conversations"
        params={{
          search: {
            requester: [requester.id],
          },
        }}
      >
        {avatar}
      </AppLink>
    );
  }
  return avatar;
};
